class productRelated extends HTMLElement {
  swiperInstance = null;
  constructor() {
    super();
    document.addEventListener("cart:update", () => {
      this.initCartRelated();
    });
    document.addEventListener("cart::drawer::open", () => {
      this.initCartRelated();
    });
   
    this.initCartRelated();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    document.addEventListener("cart:quick:add:open", () => {
      this.cart?.close()
      });
    }
  initCartRelated() {
    if (this.dataset?.url) {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");
          const recommendations = doc.querySelector(
            "cart-product-related .swiper"
          );
          $(this).find(".swiper").html(recommendations?.innerHTML);
          this.initSwiper();
        });
    }
  }
  initSwiper() {
    $(this).find("button").click((e)=>{
      e.stopPropagation()
      e.preventDefault()
    })
    const that = this;
    $(this)
      .find(".add_cart_swiper")
      .click(function () {
        const id = $(this).parents(".product_box").find("select").val()
        // 加购
        const data = {
          id,
          quantity: 1,
        };
        if (that.cart) {
          data["sections"] = that.cart
            .getSectionsToRender()
            .map((section) => section.id);
        }
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function (res) {
            if (!that.cart) {
              window.location = window.routes.cart_url;
            } else {
              that.cart.renderContents(res);
              if (that.cart && that.cart.classList.contains("is-empty"))
                that.cart.classList.remove("is-empty");
            }
          },
          dataType: "json",
        });
      });
    this.swiperInstance = new Swiper($(this).find(".swiper")[0], {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      grid: {
        fill: 'row',
        rows: 3,
      },
    });
  }
}
customElements.define("cart-product-related", productRelated);
